// EmbeddedChatView.js - Chat view component for embedding in Dashboard
import React, { useEffect } from "react";
import ViewTaskPage from "./ViewTaskPage";

export default function EmbeddedChatView({ projectId, projectName }) {
  // Override ViewTaskPage styles when embedded
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      .embedded-chat-view .container-fluid {
        min-height: auto !important;
        height: 100% !important;
        max-height: 100% !important;
        padding-top: 0 !important;
        overflow: hidden !important;
        display: flex !important;
        flex-direction: column !important;
      }
      .embedded-chat-view .whatsapp-input-container {
        position: sticky !important;
        bottom: 0 !important;
        left: 0 !important;
        right: 0 !important;
        display: flex !important;
        visibility: visible !important;
        opacity: 1 !important;
        z-index: 10 !important;
        margin-top: auto !important;
        flex-shrink: 0 !important;
      }
      .embedded-chat-view .task-header-responsive {
        display: none !important;
      }
      .embedded-chat-view .timeline-wrapper-responsive {
        overflow-y: auto !important;
        overflow-x: hidden !important;
        flex: 1 1 auto !important;
        min-height: 0 !important;
        max-height: 100% !important;
        height: auto !important;
        -webkit-overflow-scrolling: touch !important;
      }
      .embedded-chat-view .timeline-wrapper-responsive::-webkit-scrollbar {
        width: 8px;
      }
      .embedded-chat-view .timeline-wrapper-responsive::-webkit-scrollbar-track {
        background: #f1f5f9;
        border-radius: 4px;
      }
      .embedded-chat-view .timeline-wrapper-responsive::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 4px;
      }
      .embedded-chat-view .timeline-wrapper-responsive::-webkit-scrollbar-thumb:hover {
        background: #94a3b8;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  if (!projectId || !projectName) {
    return <div style={{ padding: "20px", textAlign: "center", color: "#6b7280" }}>No project selected</div>;
  }

  // Pass projectId and projectName as props to ViewTaskPage
  return (
    <div 
      className="embedded-chat-view"
      style={{ 
        width: "100%", 
        height: "calc(100vh - 200px)",
        backgroundColor: "#f9fafb",
        borderRadius: "12px",
        overflow: "hidden",
        border: "1px solid #e5e7eb",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)"
      }}
    >
      <ViewTaskPage 
        embeddedProjectId={projectId} 
        embeddedProjectName={projectName} 
      />
    </div>
  );
}

